import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FaEye, FaCalendarDay, FaCheck, FaRegQuestionCircle, FaTimes, FaUsers, FaCalendarPlus, FaComments, FaRetweet, FaPlus, FaFileAlt, FaStickyNote, FaBan, FaUserClock } from 'react-icons/fa';
import { formatToSpanishTimeZone } from '../../utils/formatDate';
import PopUpTimeLine from '../specific/popUpTimeLine';
import { FaPaperclip } from 'react-icons/fa6';
import { GetIncidentActivityTypesService } from '../../Services/incidentService';

// const ICONS = {
//   'Creación caso': FaPlus,
//   'Vista': FaCheck,
//   'Cambio de responsable': FaRetweet,
//   'Propuesta de resolución': FaRegQuestionCircle,
//   'Petición de resolución': FaCalendarPlus,
//   'Acta de reunión': FaUsers,
//   'Propuesta de reunión': FaCalendarDay,
//   'Comentario del informante': FaComments,
//   'Comentario del responsable': FaComments,
//   'Petición de reunión': FaRegQuestionCircle,
//   'Nota responsable': FaStickyNote,
//   'Nota informante': FaStickyNote,
//   'Cancelación': FaBan,
//   'Ampliación de plazo': FaUserClock,
// };

const TimeLine = ({ items, user }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const  [activityTypes, SetActivityTypes] = useState([]);

  // const shouldShowButton = (activityType) => {
  //   const typesToShowButtonFor = [
  //     'Propuesta de resolución',
  //     'Acta de reunión',
  //     'Propuesta de reunión',
  //     'Comentario del informante',
  //     'Comentario del responsable',
  //     'Propuesta de reunión',
  //     'Petición de reunión',
  //     'Cambio de responsable',
  //     'Nota responsable',
  //     'Nota informante',
  //     'Cancelación',
  //     'Ampliación de plazo',
  //   ];
  //   return typesToShowButtonFor.includes(activityType);
  // };

  const shouldShowButton = (activityType) => {
    const typesToShowButtonFor = [
      activityTypes[10],
      activityTypes[0],
      activityTypes[11],
      activityTypes[4],
      activityTypes[5],
      activityTypes[9],
      activityTypes[2],
      activityTypes[8],
      activityTypes[7],
      activityTypes[3],
      activityTypes[1],
    ];
    return typesToShowButtonFor.includes(activityType);
  };

  const ICONS = {
    [activityTypes[6]]: FaPlus,
    [activityTypes[12]]: FaCheck,
    [activityTypes[2]]: FaRetweet,
    [activityTypes[10]]: FaRegQuestionCircle,
    [activityTypes[0]]: FaUsers,
    [activityTypes[11]]: FaCalendarDay,
    [activityTypes[4]]: FaComments,
    [activityTypes[5]]: FaComments,
    [activityTypes[9]]: FaRegQuestionCircle,
    [activityTypes[8]]: FaStickyNote,
    [activityTypes[7]]: FaStickyNote,
    [activityTypes[3]]: FaBan, // Esto sobrescribirá la asignación anterior de FaRetweet a activityTypes[3]
    [activityTypes[1]]: FaUserClock,
  };
  

  useEffect(() => {  
    const getActivityTypes = async () => {
      const ActivityTypesNames = await GetIncidentActivityTypesService();
      SetActivityTypes(ActivityTypesNames);
  };
  getActivityTypes();
   }, []);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleEyeClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };
  return (
    <div className='mt-3'>
      {items.map((item, index) => {
        const IconComponent = ICONS[item.incidentActivityType];
        return (
          <Card
            key={index}
            className={`mb-0 p-2 timeline-card  ${shouldShowButton(item.incidentActivityType) ? 'timeline-card-pressable' : ''}`}
            onClick={() => shouldShowButton(item.incidentActivityType) ? handleEyeClick(item) : null}
          >
            <Card.Body className="p-0">
              <Row className="align-items-center">
                <Col xs={2} className="text-center">
                  {IconComponent && <IconComponent className='dark-gray-color' size={24} />}
                </Col>
                <Col xs={7}>
                  <div className='dark-gray-color' >{formatToSpanishTimeZone(item.createdAt, true)}</div>
                  <div className='dark-gray-color font-bold'>{item.incidentActivityType}</div>
                </Col>
                <Col xs={3} className='timeline-eye-container'>
                  {shouldShowButton(item.incidentActivityType) && (
                    <>
                      <Button
                        variant='link'
                        className={`${item.fileData ? 'timeline-eye-button': ''} `}
                        onClick={() => handleEyeClick(item)}
                      >
                        <FaEye className='timeline-eye' size={20} />
                      </Button>
                      {item.fileData ?
                        <Button
                          variant='link'
                          className="p-0"
                          onClick={() => handleEyeClick(item)}
                        >
                          <FaPaperclip className='timeline-paperclip' size={20} />
                        </Button>
                        :
                        null}
                    </>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        );
      })}
      <PopUpTimeLine
        key={1}
        show={showModal}
        onHide={handleModalClose}
        item={selectedItem}
        activityType={selectedItem?.incidentActivityType}
        readOnly={true}
        user={user}
      />
    </div>
  );
};

export default TimeLine;